import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { signOut } from 'next-auth/react';
import { clearAllStores } from '@/lib/clear-stores';
interface AuthStore {
  // Client-side auth state
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;

  // Last Used Email
  lastUsedEmail: string;
  setLastUsedEmail: (email: string) => void;

  // Auth Event
  authEvent: 'signingIn' | 'signingOut' | 'getSession';
  setAuthEvent: (event: 'signingIn' | 'signingOut' | 'getSession') => void;

  // Logout function
  logout: () => void;
}
export const useAuthStore = create<AuthStore>()(persist(set => ({
  /* -- Client-side auth state -- */
  isAuthenticated: false,
  setIsAuthenticated: value => set({
    isAuthenticated: value
  }),
  /* -- Last Used Email -- */
  lastUsedEmail: '',
  setLastUsedEmail: email => set({
    lastUsedEmail: email
  }),
  /* -- Auth Event -- */
  authEvent: 'getSession',
  setAuthEvent: event => set({
    authEvent: event
  }),
  /* -- Logout function -- */
  logout: () => {
    clearAllStores();
    signOut(); // Let NextAuth handle the redirect to login page (and clear the session)
  }
}), {
  name: 'auth-storage'
}));

// =============================================
// GRANULAR SELECTORS (Performance optimization)
// =============================================

/** Get isAuthenticated state */
export const useIsAuthenticated = () => {
  return useAuthStore(_temp);
};

/** Get lastUsedEmail */
export const useLastUsedEmail = () => {
  return useAuthStore(_temp2);
};

/** Get authEvent */
export const useAuthEvent = () => {
  return useAuthStore(_temp3);
};

/** Get setLastUsedEmail action */
export const useSetLastUsedEmail = () => {
  return useAuthStore(_temp4);
};

/** Get setAuthEvent action */
export const useSetAuthEvent = () => {
  return useAuthStore(_temp5);
};

/** Get logout action */
export const useLogout = () => {
  return useAuthStore(_temp6);
};
function _temp(state) {
  return state.isAuthenticated;
}
function _temp2(state) {
  return state.lastUsedEmail;
}
function _temp3(state) {
  return state.authEvent;
}
function _temp4(state) {
  return state.setLastUsedEmail;
}
function _temp5(state) {
  return state.setAuthEvent;
}
function _temp6(state) {
  return state.logout;
}